import { get, writable } from "svelte/store"

export const previewEntryMap = writable<{ [collection: string]: unknown }>({})

if (typeof window !== "undefined") {
    window.addEventListener(
        "message",
        (event) => {
            const pMap = get(previewEntryMap)
            pMap[event.data?.collection] = event.data?.entry
            previewEntryMap.set(pMap)
        },
        false
    )
}
